export const DEFAULT_GATEWAY_PRINCIPAL_STATUS = 'active';
export const DEFAULT_GATEWAY_PRINCIPAL_DAILY_USD = '50.00';
export const DEFAULT_GATEWAY_PRINCIPAL_MONTHLY_USD = '500.00';
export const DEFAULT_GATEWAY_PRINCIPAL_DAILY_TOKENS = '0';

function slugify(value: string, separator: '-' | '_') {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, separator)
    .replace(new RegExp(`\\${separator}+`, 'g'), separator)
    .replace(new RegExp(`^\\${separator}|\\${separator}$`, 'g'), '');
}

export function generateGatewayPrincipalToken() {
  const bytes = new Uint8Array(24);
  globalThis.crypto.getRandomValues(bytes);
  return `sk-${Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('')}`;
}

export function generateGatewayPrincipalUIDSuffix() {
  const bytes = new Uint8Array(4);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
}

export function buildGatewayPrincipalPreview(
  name: string,
  uidSuffix: string,
  token: string,
) {
  const labelSlug = slugify(name, '-');
  const uidSlug = slugify(name, '_');
  return {
    label: labelSlug ? `${labelSlug}.prod.v1` : '',
    uid: uidSlug && uidSuffix ? `team_${uidSlug}_${uidSuffix}_prod` : '',
    token,
  };
}

export function buildCreateFormDefaults() {
  return {
    status: DEFAULT_GATEWAY_PRINCIPAL_STATUS,
    authMode: 'api_key',
    authToken: generateGatewayPrincipalToken(),
    dailyUsd: DEFAULT_GATEWAY_PRINCIPAL_DAILY_USD,
    monthlyUsd: DEFAULT_GATEWAY_PRINCIPAL_MONTHLY_USD,
    dailyTokens: DEFAULT_GATEWAY_PRINCIPAL_DAILY_TOKENS,
    owner: '',
    description: '',
    metadata: {},
    generatedUIDSuffix: generateGatewayPrincipalUIDSuffix(),
  };
}
